import { connect } from 'react-redux';
import { path } from 'ramda';

import TransmissionReport from 'components/TransmissionReport';

import { fetchReportItem } from 'store/actionCreators/reports/singleItems';
import { getReportItemShouldShowLoading } from 'store/selectors/reports/singleItems';

const mapStateToProps = (state, ownProps) => {
  const reportId = path(['match', 'params', 'reportId'], ownProps);
  return {
    loading: getReportItemShouldShowLoading(reportId)(state),
  };
};

const mapDispatchToProps = {
  fetchReportItem,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TransmissionReport);
